@if (auth.user()?.department?.code === 'ACC') {
  <app-accounting-dashboard />
} @else {
  <app-sales-dashboard />
}
